require('../../../../_lib/jquery.passwordRequirementsModified');

jQuery(document).ready(() => {
  $('.pr-password').passwordRequirements();

  $('#showhide').on('click', function () {
    const btn = $(this);
    if (btn.val() == 'show') {
      btn.val('hide');
      $("input[name='password'], input[name='re-password']").attr('type', 'text');
    } else {
      btn.val('show');
      $("input[name='password'], input[name='re-password']").attr('type', 'password');
    }
  });
});
